import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAccommodationPlacePartner = loadable(
  () => import(/* webpackChunkName: "content/hotel/accommodationplacepartner" */ './AccommodationPlacePartner'),
  'AccommodationPlacePartner',
);
